// -
import React from 'react';
import {Button, Alert} from "reactstrap";
import classNames from 'classnames';

/**
 * Komponenta pro Zobrazení informace, že v seznamu jsou nová data a uživatel může data aktualizovat - reload.
 */
export default class HasNewData extends React.Component {
    static propTypes = {
        onReload: React.PropTypes.func.isRequired,    // callback pro reload
    };

    render() {
        const {onReload, className, ...other} = this.props;

        const cls = classNames(
            "has-new-data",
            className
        );
        return (
            <div className={cls} {...other}>
                <Alert color="info">Nalezeny nové záznamy <Button color="link" onClick={onReload}>Aktualizovat</Button></Alert>
            </div>
        );
    }

};
